import React, { FC, ReactNode } from 'react';
import { Cell, Grid }           from "styled-css-grid";

import { CorvalLogo, CorvalLogoVersions } from './CorvalLogo';


interface Props {
    value?: ReactNode,
    marginAuto?: boolean,
    useChildCell?: boolean,
    useColon?: boolean,
    usePrefix?: boolean,
}

const defaultProps: Props = {
    value:        null,
    marginAuto:   true,
    useColon:     false,
    usePrefix:    true,
    useChildCell: false,
}

const CorvalRecommendedStatement: FC<Props> = ( props ) => {

    if( !props.value ) return null;

    return (

        <Grid columns={ `auto 1fr` }
              style={ {
                  maxWidth: 'fit-content',
                  margin:   props?.marginAuto ? 'auto' : undefined
              } }>

            <Cell middle={ !props.useChildCell }>
                <CorvalLogo type={ CorvalLogoVersions.COLOR_HEX_LOGO } width={ 16 } inline/>
            </Cell>

            { ( props.usePrefix || !props.useChildCell ) && (
                <Cell middle>
                    <p>
                        { props.usePrefix ? <>Corval recommends{ props.useColon ? ': ' : ' ' }</> : null }
                        { !props.useChildCell && <strong>{ props.value }</strong> }
                    </p>
                </Cell>
            ) }

            { props.useChildCell && <Cell left={ 2 }>{ props.value }</Cell> }
        </Grid>
    );
};

CorvalRecommendedStatement.defaultProps = defaultProps;

export { CorvalRecommendedStatement }
